import { html } from 'lit';
import { Purpose } from '@common/types/model';
import type { TefComs4p } from '@src/components/TefComs4p';

//
// renders a single user bound purpose in EDIT mode
//
export const singlePurposeUserBoundEdit = function render(this: TefComs4p, purpose : Purpose) {
  return html`
    <one-section size="xxs" background="muted-2">
      <one-heading level="h6" variant="default">Vertragsinhaber</one-heading>
    </one-section>

    <one-stack gap="xs">
      ${purpose.apps!.map((app) => this.getTemplateFn('singleAppConsentEdit')(app))}
      <one-checkbox ?checked="${!purpose.apps!.some((app) => app.granted)}" @change=${() => { this.revokeAllAppConsentsForPurpose(purpose); }}>
        <one-text size="lg">Alle deaktivieren</one-text>
      </one-checkbox>
    </one-stack>
  `;
};
